import React, {useEffect, useState} from "react";
import {DeleteButton} from "../../../helpers/ButtonHelper";
import {deleteItem} from "../../../helpers/Api";
import {useMutation, useQuery} from "@apollo/client";
import {deletePlateIngredientMutation, getPlateIngredients} from "./PlateQueries";
import ListTable from "../../shared/ListTable";
import EditPlateIngredientModal from "./EditPlateIngredientModal";
import AddPlateIngredientModal from "./AddPlateIngredientModal";
import PageSubTitle from "../../../layout/PageSubTitle";
import Loader from "../../shared/Loader";

const PlateIngredientsList = ({ plate }) => {
  const [ingredients, setIngredients] = useState([])
  const { loading, data, refetch } = useQuery(getPlateIngredients, { variables: { plateId: plate.id } })
  const [deleteCall] = useMutation(deletePlateIngredientMutation, { refetchQueries: [getPlateIngredients] })

  useEffect(() => {
    if (data)
      setIngredients(data.plateIngredients)
  }, [data]);

  const header = <tr>
    <th>Ingredient</th>
    <th>Cantitate</th>
    <th className='actions'>
      <AddPlateIngredientModal showButton={true} plateId={plate.id}
                               refetch={refetch} onClose={refetch}
                               plateIngredientIds={ingredients.map(a => a.ingredient.id)}
      />
    </th>
  </tr>

  const listItem = (item, index) => {
    return <tr key={index}>
      <td>
        {item.ingredient.name}
      </td>
      <td>
        {item.qty}
        &nbsp;
        {item.unit.name}
        &nbsp;
        {item.qtyInfo && `(${item.qtyInfo})`}
      </td>
      <td className='actions'>
        <EditPlateIngredientModal
          showButton={true} plateIngredient={item}
          plateIngredientIds={ingredients.map(a => a.ingredient.id)}
        />
        <DeleteButton onClick={e => deleteItem(e, item.id, deleteCall)} />
      </td>
    </tr>
  }

  return (
    <div className="row justify-content-md-center">
      <PageSubTitle title='Ingrediente' />
      <div className="page-container  ">
        {loading ?
          <Loader />
          :
          <ListTable data={ingredients} header={header} listItem={listItem} />
        }
      </div>
    </div>
  )
};

export default PlateIngredientsList;
